import Typography from '@mui/material/Typography';
import type React from 'react';
import AkomiDialog from './AkomiDialog';
import AkomiDialogActions from './AkomiDialogActions';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  confirmDisabled?: boolean;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmDisabled = false,
}) => {
  return (
    <AkomiDialog
      open={isOpen}
      onClose={onCancel}
      title={title}
      actions={
        <AkomiDialogActions
          variant="cancel-confirm"
          primaryLabel="Yes"
          secondaryLabel="No"
          onPrimary={onConfirm}
          onSecondary={onCancel}
          primaryDisabled={confirmDisabled}
        />
      }
    >
      <Typography component="div">{message}</Typography>
    </AkomiDialog>
  );
};

export default ConfirmDialog;
